export default "__VITE_ASSET__DaMpw4dE__"